import { Fragment, useState } from "react";
import { Button, Card, Col, Form, ProgressBar, Row } from "react-bootstrap";
import { CCArticleResult } from "../../Models/Assessment";
import { AbccAssessment, AbccAssessmentCertification } from "../Models/CCAssessment";
import { AbccAssessmentCertificationCard } from "./AbccAssessmentCertificationCard";
import { ArticleResultList } from "./ArticleResultList";
import { CCBlock } from "../../../Physician/Models/CCBlock";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";

interface IProps{
    abccAssessment: AbccAssessment,
    ccBlock: CCBlock
}
export function AbccAssessmentCard(props: IProps) {
    const [detailVisible, setDetailVisible] = useState<boolean>(false);
     
    
    const getTotalPassed = () => {
        var totalPassed = 0;
        if (props.abccAssessment.abccAssessmentCertifications){
            for (var i = 0; i < props.abccAssessment.abccAssessmentCertifications.length; i++){
                if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults)
                {
                    for (var a = 0; a < props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults.length; a++)
                    {
                        if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults[a].isPass)
                        {
                            totalPassed++;
                        }
                    }
                }    
            }
        }

        return totalPassed;
    }

    const getTotalFailed = () => {
        var totalFailed = 0;
        if (props.abccAssessment.abccAssessmentCertifications){
            for (var i = 0; i < props.abccAssessment.abccAssessmentCertifications.length; i++){
                if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults)
                {
                    for (var a = 0; a < props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults.length; a++)
                    {
                        if (!props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults[a].isPass)
                        {
                            totalFailed++;
                        }
                    }
                }    
            }
        }

        return totalFailed;
    }

    const anyCertsFailed = () => {
        if (props.abccAssessment.abccAssessmentCertifications){
            for (let i = 0; i < props.abccAssessment.abccAssessmentCertifications.length; i++){
                if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults)
                {
                    let certFails = 0;
                    for (let a = 0; a < props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults.length; a++)
                    {
                        if (!props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults[a].isPass)
                        {
                            certFails++;
                        }
                    }

                    if (certFails > props.abccAssessment.perCertificateMaxFailsAllowed){
                        return true;
                    }
                }    
            }
        }

        return false;
    }


    const allCertificationsMeetMinimumRequirement = () =>{    
        if (props.abccAssessment.abccAssessmentCertifications){
            for (var i = 0; i < props.abccAssessment.abccAssessmentCertifications.length; i++){
                var certTotalPassed = 0;
                if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults)
                {
                    for (var a = 0; a < props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults.length; a++)
                    {
                        if (props.abccAssessment.abccAssessmentCertifications[i].ccArticleResults[a].isPass)
                        {
                            certTotalPassed++;
                        }
                    }

                    certTotalPassed += props.abccAssessment.abccAssessmentCertifications[i].waivedArticles;
                }

                if (certTotalPassed < props.abccAssessment.perCertificateArticleRequirement){
                    return false;
                }
            }
        }

        return true;
    }


    const totalPassedIncludingWaived = getTotalPassed() + props.abccAssessment.waivedArticles;
    const totalPercentPassed = totalPassedIncludingWaived / props.abccAssessment.totalArticleRequirement * 100;
    const totalPercentFailed = getTotalFailed() / (props.abccAssessment.attemptsAllowed - props.abccAssessment.totalArticleRequirement) * 100;
    const totalFailMax = props.abccAssessment.attemptsAllowed - props.abccAssessment.totalArticleRequirement

    const getStatusMessage = () => {
    
        if (totalPassedIncludingWaived >= props.abccAssessment.totalArticleRequirement && !anyCertsFailed() && allCertificationsMeetMinimumRequirement()){
            return `Congratulations!  You have passed ${totalPassedIncludingWaived} of ${props.abccAssessment.totalArticleRequirement} article exams needed to pass.`
        }
        else if (props.abccAssessment.abccAssessmentCertifications?.length > 1 && !anyCertsFailed() && (totalPassedIncludingWaived < props.abccAssessment.totalArticleRequirement || !allCertificationsMeetMinimumRequirement()))
        {
            return `You have passed ${totalPassedIncludingWaived} of ${props.abccAssessment.totalArticleRequirement} total article exams. At least ${props.abccAssessment.perCertificateArticleRequirement} article exams are required in each certification to meet requirements. You have ${props.abccAssessment.attemptsAllowed - getTotalFailed() - getTotalPassed()} article attempts exams remaining.`
        }
        else if (props.abccAssessment.abccAssessmentCertifications?.length == 1 && !anyCertsFailed() && (totalPassedIncludingWaived < props.abccAssessment.totalArticleRequirement || !allCertificationsMeetMinimumRequirement()))
        {
            return `You have passed ${totalPassedIncludingWaived} of ${props.abccAssessment.totalArticleRequirement} total article exams. You have ${props.abccAssessment.attemptsAllowed - getTotalFailed() - getTotalPassed()} article attempts exams remaining.`
        }
        if (getTotalFailed() + props.abccAssessment.totalArticleRequirement > props.abccAssessment.attemptsAllowed)
        {
            return "You have exceeded the number of failed article exams. You will be required to pass an exam in order to maintain certification"
        } 
        else if (anyCertsFailed())
        {
            return "You have exceeded the number of failed article exams for at least one certification. Any failed certifiation in the ABCC pathway must be changed to the Examination Pathway. The pathway can be changed by clicking Edit CC Enrollment in the CC Enrollment Summary."
        }
        else{
            return "";
        }
    }

    const articleResultsExist = () => {
        return getAllArticleResults().length > 0
    }

    const getAllArticleResults = () => {
        var allArticleResults = Array<CCArticleResult>();
        props.abccAssessment.abccAssessmentCertifications.map((abccAssessmentCertification: AbccAssessmentCertification) => {
            abccAssessmentCertification.ccArticleResults && abccAssessmentCertification.ccArticleResults.map((ccArticleResult: CCArticleResult) => {
                allArticleResults.push(ccArticleResult);
            })
        })

        return allArticleResults;
    }

    const anyArticlesCompletedBeforeBlockStart = () => {
        var blockStartDate = getDateWithOffset(props.ccBlock.startDate);
        var articlesBeforeBlockStart = getAllArticleResults().filter(_ => _.isPass && getDateWithOffset(_.completedDate) < blockStartDate);
        
        return articlesBeforeBlockStart && articlesBeforeBlockStart.length > 0;
    }

    
    return(
        <Fragment>
            <Row className="align-items-end">
                <Col>
                    <Form.Group controlId="dueDate">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Article Exams Due By</Form.Label>
                        <Form.Text>{props.abccAssessment.dueDate}</Form.Text>                    
                    </Form.Group>
                </Col>
            </Row>
            {(props.abccAssessment.waivedArticles > 0 || anyArticlesCompletedBeforeBlockStart()) && 
                <Row className="align-items-end">
                    <Col>
                        <div className="alert alert-white-text alert-primary"><strong>IMPORTANT</strong><br />
                            <ul>
                                <li>Credits below reflect all Pilot and ABCC article exam credits.</li>
                                <li>DO NOT exceed the number of passed exams required for this block.</li>
                                <li>Any extra completed article exams will not be credited to future blocks.</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            }
            <Row noGutters className="align-items-end">
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">&nbsp;</Form.Label> 
                    </Col>
                    <Col className="text-center col-4">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Passed</Form.Label> 
                    </Col>
                    <Col className="text-center col-4">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Failed</Form.Label> 
                    </Col>
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Total Attempts</Form.Label> 
                    </Col>
                </Row>
            {props.abccAssessment.abccAssessmentCertifications?.length > 1 && props.abccAssessment.abccAssessmentCertifications?.map((abccAssessmentCertification: AbccAssessmentCertification) => {                
                    return <AbccAssessmentCertificationCard key={abccAssessmentCertification.certificationId}
                                        abccAssessmentCertification={abccAssessmentCertification} 
                                        perCertificateArticleRequirement={props.abccAssessment.perCertificateArticleRequirement}
                                        perCertificateMaxFailsAllowed={props.abccAssessment.perCertificateMaxFailsAllowed} />})
            }
            
            <Row noGutters className="align-items-center mb-0">
                <Col className="text-left col-2">
                    <Form.Label className="mb-0 pp-font-size-smaller">{props.abccAssessment.abccAssessmentCertifications?.length > 1 ? "Total" : props.abccAssessment.abccAssessmentCertifications[0].certificationName}</Form.Label> 
                </Col>
                <Col className="col-4 text-right" style={{height: "26px" }}>
                    <Form.Group controlId="articleProgress">
                        <div className="d-flex flex-row ">
                            <div className="w-75 mb-1 mt-1">
                                <ProgressBar variant="pp-secondary" role="progressbar" now={totalPercentPassed} max={100} ></ProgressBar>
                            </div>
                            <Form.Text className="ml-1">{totalPassedIncludingWaived}/{props.abccAssessment.totalArticleRequirement}</Form.Text>        
                        </div>                  
                    </Form.Group>
                </Col>
                <Col className="col-4 text-right" style={{height: "26px" }}>
                    <Form.Group controlId="articleProgress">
                        <div className="d-flex flex-row ">
                            <div className="w-75 mb-1 mt-1">
                                <ProgressBar variant="pp-secondary" role="progressbar" now={totalPercentFailed} max={100} ></ProgressBar>
                            </div>
                            <Form.Text className={"ml-1 " + (getTotalFailed() > totalFailMax ? "pp-danger-text" : "")}>{getTotalFailed()}/{totalFailMax}</Form.Text>        
                        </div>                  
                    </Form.Group>
                </Col>
                <Col className="text-center col-2">
                    <Form.Label className="mb-0 pp-font-size-smaller">{getTotalPassed() + getTotalFailed()}/{props.abccAssessment.attemptsAllowed}</Form.Label> 
                </Col>
            </Row>
            <Row noGutters>
                <Col className="text-center col-11">
                    <Form.Label className="font-weight-bolder mt-2 pp-font-size-smaller">{getStatusMessage()}</Form.Label>
                </Col>
            </Row>
            { detailVisible &&
                <Row>
                    <ArticleResultList articleResults={getAllArticleResults()}/>
                </Row>
            }
            <Card bsPrefix="border-0 pp-align-self-end mt-2">
                <a href="https://moc.abpn.com" target="_blank"><Button variant="pp-primary" className="mb-3 mr-1">Access Article Exams<i className="ml-1 las la-external-link-alt"></i></Button></a>
                { articleResultsExist() && <Button className="mb-3" variant="outline-pp-primary" onClick={() => setDetailVisible(!detailVisible)}>{detailVisible ? "Hide" : "Show"} Detail</Button>}
            </Card>
            <div className="pp-font-size-smallest">* Clicking 'Access Article Exams' will navigate you to the article portal</div>
            <hr className="mt-0"/>
        </Fragment>
    );
}

export default AbccAssessmentCard;